import React, { useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';
import moment from 'moment';

import ResourceNotifications from 'app/src/components/Notifications/Resource';
import { SubNavContainer, LinkSpace } from 'app/src/elements';
import Modal from 'app/src/elements/Modal';

import EditAsset from './edit';
import elRed from '../../styles/colors';

const BoldText = styled(Text)`
  font-weight: 700;
`;

const SubNav = ({ asset, refetch }) => {
  const [showEditModal, setShowEditModal] = useState(false);

  return (
    <SubNavContainer>
      <BoldText>
        {asset.name}
        <Text style={{color: elRed}}>
          {
            asset.status === 'Not Yet Ready' ? ' - ' + asset.status : ''
          }
        </Text>
      </BoldText>
      <LinkSpace />
      <Pressable onPress={() => setShowEditModal(true)}>
        <Text>Edit</Text>
      </Pressable>
      {asset && (
        <>
          {asset?.activeSaleAsset && (
            <>
              <LinkSpace />
              <Text style={{fontWeight: 600}}>
                {asset.activeSaleAsset.lotNumber}
                {' '}
                {moment(asset.activeSaleAsset.sale.saleOn).format('M/D/YY')}
              </Text>
            </>
          )}
          <LinkSpace />
          <View>
            <ResourceNotifications resource={asset} labeled />
          </View>
        </>
      )}
      {showEditModal && (
        <Modal
          showModal={showEditModal}
          setShowModal={setShowEditModal}
          modalType="Edit Asset"
        >
          <EditAsset
            setShowModal={setShowEditModal}
            asset={asset}
            refetch={refetch}
          />
        </Modal>
      )}
    </SubNavContainer>
  );
};

export default SubNav;
